import { useSubscribeToPrivateWebsocketEvent } from '~/core/shared/contexts/websockets';
import { User } from '../../../../types';
import { buildUserChannelName } from '../../../user/logic/buildUserChannelName';
import { CreditBureauPrivateWebsocketEvent } from '../../types/CreditBureauPrivateWebsocketEvent';
import { CreditBureauPrivateWebsocketEventPayload } from '../../types/CreditBureauPrivateWebsocketEventPayload';

/**
 * The bureau enquiry is broadcast to whoever started it, so this listens on that user's own channel rather than the
 * deal's: the result follows the operator even if they have navigated away from the deal.
 */
export const useSubscribeToIndividualCreditEnquiryCompleted = (
  userId: User['id'],
  onCompleted: (
    payload: CreditBureauPrivateWebsocketEventPayload[CreditBureauPrivateWebsocketEvent.IndividualCreditEnquiryCompleted],
  ) => void,
): void => {
  useSubscribeToPrivateWebsocketEvent(
    buildUserChannelName(userId),
    CreditBureauPrivateWebsocketEvent.IndividualCreditEnquiryCompleted,
    onCompleted,
  );
};
